import { Button, Card, Form, Input, notification, Typography } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useGoogleLogin } from 'react-google-login';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import myLogo from '../assets/Passwords-logos_transparent.png';
import settings from '../settings';
import { AuthContext } from '../shared/auth-context';
import { toHexString } from '../shared/crypto-utils';
import useProfile from '../shared/use-profile';

const { Title, Text } = Typography;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  const authContext = useContext(AuthContext);
  const history = useHistory();

  const onFinish = async (values) => {
    setLoading(true);
    setServerError(null);
    let error;
    const { name, email, plainPassword } = values;
    try {
      error = await authContext.signUp({
        name: name.trim(),
        email: email.trim().toLowerCase(),
        plainPassword,
      });
      history.push('/sign-in');
      notification.success({
        title: 'Success',
        message: 'Account created, please sign in.',
      });
    } catch (err) {
      setServerError(err.message);
      setLoading(false);
    }
  };

  const profile = useProfile();
  useEffect(() => {
    if (profile) {
      history.push('/map');
    }
  }, [profile, history]);

  return (
    <div className="page qr-gen">
      <div className="logo-box">
        <img className="logo" src={myLogo} alt="MG Logo" />
      </div>
      <Card>
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          className="signin-form"
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter your name',
              },
            ]}
          >
            <Input disabled={loading} />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}
          >
            <Input disabled={loading} />
          </Form.Item>
          <Form.Item
            name="plainPassword"
            label="Password"
            rules={[
              {
                required: true,
                message: 'Please enter a password',
              },
            ]}
            hasFeedback
          >
            <Input.Password disabled={loading} />
          </Form.Item>
          <Form.Item
            name="confirm"
            label="Confirm Password"
            dependencies={['plainPassword']}
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Please confirm your password',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('plainPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    'The two passwords that you entered do not match!',
                  );
                },
              }),
            ]}
          >
            <Input.Password disabled={loading} />
          </Form.Item>
          <Form.Item>
            {/* <Button
              type="link"
              htmlType="button"
              onClick={() => history.push('/sign-up')}
            >
              Sign Up
            </Button> */}
            <div className="sign-in-btns">
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: 150 }}
                loading={loading}
              >
                Create Account
              </Button>
            </div>
          </Form.Item>
          {serverError && (
            <div
              className="server-error ant-form-item-has-error"
              style={{ marginTop: 16 }}
            >
              <div className="ant-form-item-explain">{serverError}</div>
            </div>
          )}
          {/* <Divider>Or</Divider>
          <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
            <Space
              align="center"
              style={{
                flexWrap: 'wrap',
                width: '100%',
                justifyContent: 'center',
              }}
            >
              <Button
                onClick={() => googleLogin.signIn()}
                icon={<GoogleOutlined />}
                style={{ marginBottom: 8 }}
                loading={googleLogin.loading}
              >
                Sign in with Google
              </Button>
              <Button
                onClick={() => authContext.signInWithApple()}
                icon={<AppleOutlined />}
                style={{ marginBottom: 8 }}
              >
                Sign in with Apple
              </Button>
            </Space>
          </Form.Item> */}
        </Form>
      </Card>
      <style jsx>{`
        .page {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding-top: 10vh;
          padding-bottom: 10vh;
        }
        .subtitle {
          font-size: 24px;
        }
        .server-error {
          text-align: center;
        }
        .sign-in-btns {
          display: flex;
          justify-content: center;
        }
        .logo {
          max-width: 400px;
          margin-left: 16px;
          margin-right: 16px;
        }
        .logo-sep {
          margin-left: 16px;
          margin-right: 16px;
          border-right: 1px solid #e8e8e8;
          height: 150px;
        }
        .logo-box {
          display: flex;
          flex-wrap: no-wrap;
          max-width: 100%;
          padding-left: 64px;
          padding-right: 64px;
          margin-left: -16px;
          margin-right: -16px;
          align-items: center;
          margin-bottom: 32px;
        }
        @media screen and (max-width: 992px) {
          .logo {
            max-width: unset;
            width: 35vw;
          }
          .logo-box {
            margin-top: 16px;
            margin-bottom: 16px;
            padding-left: 8px;
            padding-right: 8px;
          }
        }
        @media screen and (max-width: 600px) {
          .logo {
            max-width: unset;
            width: 35vw;
          }
          .logo-box {
            margin-top: 16px;
            margin-bottom: 16px;
            padding-left: 8px;
            padding-right: 8px;
          }
        }
      `}</style>
      <style jsx global>{`
        .qr-gen-title {
          text-align: center;
        }
        .ant-form-item-explain,
        .ant-form-item-extra {
          padding-bottom: 8px;
        }
        .signin-form {
          width: 30vw;
        }
        @media screen and (max-width: 992px) {
          .signin-form {
            width: 60vw;
          }
        }
        @media screen and (max-width: 600px) {
          .signin-form {
            width: 80vw;
          }
        }
      `}</style>
    </div>
  );
};

export default SignUp;
